import { Post } from '../models/core.models';
import { createAction, props } from '@ngrx/store';

export const togglePostSelect = createAction(
  '[Feed] Select Post',
  props<{ postId: string; feedId: string; selected: boolean }>(),
);

export const applyPostAlgorithm = createAction(
  '[Post] Apply Post Algorithm',
  props<{ postId: string }>(),
);

export const applyPostAlgorithmSuccess = createAction(
  '[Post] Apply Post Algorithm Success',
  props<{ posts: Post[] }>(),
);

/**
 * The per-card spinner for a selection-wide run. Callers pass the ids in, read off
 * `FeedPostsService.selectedPostIds()`.
 */
export const applySelectedPostsAlgorithm = createAction(
  '[Post] Apply Selected Posts Algorithm',
  props<{ postIds: string[] }>(),
);

export const applySelectedPostsAlgorithmSuccess = createAction(
  '[Post] Apply Selected Posts Algorithm Success',
  props<{ feedId: string; postIds: string[] }>(),
);

export const openPostDetails = createAction(
  '[Post] Open Post Details',
  props<{ postId: string }>(),
);
